import { Link } from "react-router-dom";
import { Warning, X } from "@phosphor-icons/react";
import { ROLE_LABEL } from "@/lib/format";
import { roleHome } from "@/components/RoleGuard";

/**
 * Modal shown when an authenticated user tries to perform an action that
 * requires a different account role. It never auto-converts the account.
 */
export default function WrongRoleModal({ open, onClose, currentRole, requiredRole }) {
    if (!open) return null;
    const requiredLabel = ROLE_LABEL[requiredRole] || requiredRole;
    const currentLabel = ROLE_LABEL[currentRole] || currentRole;
    return (
        <div
            className="fixed inset-0 z-[80] bg-black/50 grid place-items-center p-4"
            onClick={onClose}
            data-testid="wrong-role-modal"
        >
            <div
                className="bg-white rounded-2xl max-w-md w-full p-6 sm:p-8 relative"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 w-8 h-8 rounded-full hover:bg-secondary grid place-items-center"
                    data-testid="wrong-role-close"
                    aria-label="Cerrar"
                >
                    <X size={16} />
                </button>
                <span className="inline-flex w-11 h-11 rounded-xl bg-[#E8A33A]/10 text-[#B88429] items-center justify-center mb-4">
                    <Warning size={24} weight="fill" />
                </span>
                <h2 className="font-display font-bold text-xl mb-2" data-testid="wrong-role-title">
                    Esta función requiere una cuenta de {requiredLabel}
                </h2>
                <p className="text-sm text-muted-foreground leading-relaxed">
                    Tu cuenta actual está registrada como <strong>{currentLabel}</strong>. Esta acción
                    solo está disponible para cuentas de <strong>{requiredLabel}</strong>.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 mt-6">
                    <Link
                        to={roleHome(currentRole)}
                        onClick={onClose}
                        className="btn-primary flex-1 justify-center"
                        data-testid="wrong-role-back"
                    >
                        Volver a mi cuenta
                    </Link>
                </div>
            </div>
        </div>
    );
}
